export default __webpack_public_path__ + "static/media/ios.ea662121.svg";